export const MIN_PRODUCT_VALUES = {
  auto: 30_000,
  other: 5_000,
  otro: 5_000,
};
